// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f780859b","453":"ffb69a9b"}[chunkId] + ".chunk.js";
};